module.exports = __webpack_public_path__ + "img/10-11-2.96608a49.jpg";